import { defineMessages } from 'react-intl';

const translations = {
  editDrawer: {
    title: {
      id: 'pages.profile.information.editDrawer.title',
      defaultMessage: 'Edit profile',
      description: 'title of the edit profile drawer',
    },
  },
  actions: {
    edit: {
      id: 'actions.edit',
      defaultMessage: 'Edit',
      description: 'label of the edit button',
    },
  },
  feedback: {
    profileSaved: {
      id: 'pages.profile.information.feedback.profileSaved',
      defaultMessage: 'Profile has been saved',
      description: 'feedback on a successful save of profile information',
    },
    profileNotSaved: {
      id: 'pages.profile.information.feedback.profileNotSaved',
      defaultMessage: 'Profile could not be saved',
      description: 'feedback on a failed save of profile information',
    },
  },
};

export default defineMessages(translations);
